import store from "../store";
import { appContextApi } from "../redux/appContext";



export const LogToDB = async (action: string, parameter: string): Promise<void> => {
	// Can't use hooks (eg. const dispatch = useAppDispatch();) as it is not a 'functional component'
	const postLog = store.dispatch(appContextApi.endpoints.postLogDB.initiate({action,'data':parameter}))
	await postLog.unwrap().then(dat=>dat).catch(err=>console.log(err));
};

export default LogToDB;